
<script>
    export let row = {};
</script>

{#if row.main_work_centre.name}
    {row.main_work_centre.name}
{:else} 
    -
{/if}
